import {
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import * as fromStore from '../../store';

@Component({
  selector: 'app-contact-admin',
  template: `
    <div class="mx-auto max-w-xl py-6">
      <section
        class="flex flex-col rounded-xl bg-white p-8 text-center shadow-md"
      >
        <h1>Unauthorized Access</h1>
        <div class="mt-4">
          <p>
            You currently do not have access permissions in MyPortal. Please
            reach out to your account manager for assistance:
          </p>

          <div class="font-lato my-6 flex min-w-[150px] flex-col text-lg">
            <p>
              {{
                (loggedInUser$ | async)?.Account?.Account_Manager__r?.Name ||
                  'N/A'
              }}
            </p>
            @if ((loggedInUser$ | async)?.Account?.Account_Manager__r?.Phone) {
              <p>
                <strong>Phone:</strong>
                {{
                  (loggedInUser$ | async)?.Account?.Account_Manager__r?.Phone ||
                    'N/A'
                }}
              </p>
            }
            <p>
              <a
                [href]="
                  'mailto:' +
                  ((loggedInUser$ | async)?.Account?.Account_Manager__r
                    ?.Email || '')
                "
              >
                {{
                  (loggedInUser$ | async)?.Account?.Account_Manager__r?.Email ||
                    'N/A'
                }}
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AccessDeniedComponent implements OnInit {
  private store = inject(Store<fromStore.State>);

  loggedInUser$ = this.store.select(fromStore.getCurrentUser);

  ngOnInit(): void {
    this.store
      .select(fromStore.getCurrentUserLoaded)
      .pipe(take(1))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(new fromStore.LoadCurrentUser());
        }
      });
  }
}
